/**
=========================================================
* Material Dashboard 2 React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Grid from "@mui/material/Grid";
import SaveAltOutlinedIcon from "@mui/icons-material/SaveAltOutlined"; // Data

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import { baseURL } from "utils/api";
import axios from "axios";
import { useState, useEffect } from "react";
// Material Dashboard 2 React example components
import DashboardLayout from "../../examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "../../examples/Navbars/DashboardNavbar";
import Footer from "../../examples/Footer";
import TextField from "@mui/material/TextField";
import { useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";
import Button from "../../components/ButtonUse.jsx";
// Data

// Dashboard components

function EditShop() {
  const [country, setCountry] = useState([]);
  const [categoryName, setCategoryName] = useState("");
  const [selectedOption, setSelectedOption] = useState("");
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const handleSearchChange = (event) => {
    setCategoryName(event.target.value);
    setSelectedOption("");
    setIsDropdownOpen(!!event.target.value);
  };

  const handleOptionSelect = (option) => {
    setSelectedOption(option);
    setCategoryName("");
    setIsDropdownOpen(false);
  };
  const handleInputChange = (event) => {
    setCategoryName(event.target.value);
  };

  const filteredOptions = country.filter((option) =>
    option.toLowerCase().includes(categoryName.toLowerCase())
  );

  useEffect(() => {
    const getCountryData = async () => {
      try {
        // console.log(categoryName1, "aaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaa");
        const response = await fetch(
          `${process.env.REACT_APP_BASE_URL}/categories/searchCategoriesName?categoryName=${categoryName}`
        );
        if (!response.ok) {
          // throw new Error('Data not valid');
        }

        const data = await response.json();
        if (data && Array.isArray(data.data)) {
          setCountry(data.data.map((item) => item.categoryName));
        }
      } catch (error) {
        console.error("Error fetching country data:", error);
      }
    };

    getCountryData();
  }, [categoryName]);

  //---------------------------------SECOND TEXTFIELD--------------------------------------------------//
  const [country1, setCountry1] = useState([]);
  const [categoryName1, setCategoryName1] = useState("");
  const [selectedOption1, setSelectedOption1] = useState("");
  const [isDropdownOpen1, setIsDropdownOpen1] = useState(false);
  const handleSearchChange1 = (event) => {
    setCategoryName1(event.target.value);
    setSelectedOption1("");
    setIsDropdownOpen1(!!event.target.value);
  };

  const handleOptionSelect1 = (option) => {
    setSelectedOption1(option);
    setCategoryName1("");
    setIsDropdownOpen1(false);
  };
  const handleInputChange1 = (event) => {
    setCategoryName1(event.target.value);
  };
  const filteredOptions1 = country1.filter((option) =>
    option.toLowerCase().includes(categoryName1.toLowerCase())
  );

  useEffect(() => {
    const getCountryData = async () => {
      try {
        // console.log(categoryName1, "aaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaa");
        const response = await fetch(
          `${process.env.REACT_APP_BASE_URL}/categories/searchCategoriesName?categoryName=${categoryName1}`
        );
        if (!response.ok) {
          // throw new Error('Data not valid');
        }

        const data = await response.json();
        if (data && Array.isArray(data.data)) {
          setCountry1(data.data.map((item) => item.categoryName));
        }
      } catch (error) {
        console.error("Error fetching country data:", error);
      }
    };

    getCountryData();
  }, [categoryName1]);
  //  ------------------------------Third textfield------------------------------------------//
  const [country2, setCountry2] = useState([]);
  const [categoryName2, setCategoryName2] = useState("");
  const [selectedOption2, setSelectedOption2] = useState("");
  const [isDropdownOpen2, setIsDropdownOpen2] = useState(false);
  const handleSearchChange2 = (event) => {
    setCategoryName2(event.target.value);
    setSelectedOption2("");
    setIsDropdownOpen2(!!event.target.value);
  };

  const handleOptionSelect2 = (option) => {
    setSelectedOption2(option);
    setCategoryName2("");
    setIsDropdownOpen2(false);
  };
  const handleInputChange2 = (event) => {
    setCategoryName2(event.target.value);
  };

  const filteredOptions2 = country2.filter((option) =>
    option.toLowerCase().includes(categoryName2.toLowerCase())
  );

  useEffect(() => {
    const getCountryData = async () => {
      try {
        // console.log(categoryName1, "aaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaa");
        const response = await fetch(
          `${process.env.REACT_APP_BASE_URL}/categories/searchCategoriesName?categoryName=${categoryName2}`
        );
        if (!response.ok) {
          // throw new Error('Data not valid');
        }

        const data = await response.json();
        if (data && Array.isArray(data.data)) {
          setCountry2(data.data.map((item) => item.categoryName));
        }
      } catch (error) {
        console.error("Error fetching country data:", error);
      }
    };

    getCountryData();
  }, [categoryName2]);
  //  ------------------------------Fourth textfield------------------------------------------//
  const [country3, setCountry3] = useState([]);
  const [categoryName3, setCategoryName3] = useState("");
  const [selectedOption3, setSelectedOption3] = useState("");
  const [isDropdownOpen3, setIsDropdownOpen3] = useState(false);
  const handleSearchChange3 = (event) => {
    setCategoryName3(event.target.value);
    setSelectedOption3("");
    setIsDropdownOpen3(!!event.target.value);
  };

  const handleOptionSelect3 = (option) => {
    setSelectedOption3(option);
    setCategoryName3("");
    setIsDropdownOpen3(false);
  };
  const handleInputChange3 = (event) => {
    setCategoryName3(event.target.value);
  };

  const filteredOptions3 = country3.filter((option) =>
    option.toLowerCase().includes(categoryName3.toLowerCase())
  );

  useEffect(() => {
    const getCountryData = async () => {
      try {
        // console.log(categoryName1, "aaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaa");
        const response = await fetch(
          `${process.env.REACT_APP_BASE_URL}/categories/searchCategoriesName?categoryName=${categoryName3}`
        );
        if (!response.ok) {
          // throw new Error('Data not valid');
        }

        const data = await response.json();
        if (data && Array.isArray(data.data)) {
          setCountry3(data.data.map((item) => item.categoryName));
        }
      } catch (error) {
        console.error("Error fetching country data:", error);
      }
    };

    getCountryData();
  }, [categoryName3]);
  //  ------------------------------Fifth textfield------------------------------------------//
  const [country4, setCountry4] = useState([]);
  const [categoryName4, setCategoryName4] = useState("");
  const [selectedOption4, setSelectedOption4] = useState("");
  const [isDropdownOpen4, setIsDropdownOpen4] = useState(false);
  const handleSearchChange4 = (event) => {
    setCategoryName4(event.target.value);
    setSelectedOption4("");
    setIsDropdownOpen4(!!event.target.value);
  };

  const handleOptionSelect4 = (option) => {
    setSelectedOption4(option);
    setCategoryName4("");
    setIsDropdownOpen4(false);
  };
  const handleInputChange4 = (event) => {
    setCategoryName4(event.target.value);
  };

  const filteredOptions4 = country4.filter((option) =>
    option.toLowerCase().includes(categoryName4.toLowerCase())
  );

  useEffect(() => {
    const getCountryData = async () => {
      try {
        // console.log(categoryName1, "aaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaa");
        const response = await fetch(
          `${process.env.REACT_APP_BASE_URL}/categories/searchCategoriesName?categoryName=${categoryName4}`
        );
        if (!response.ok) {
          // throw new Error('Data not valid');
        }

        const data = await response.json();
        if (data && Array.isArray(data.data)) {
          setCountry4(data.data.map((item) => item.categoryName));
        }
      } catch (error) {
        console.error("Error fetching country data:", error);
      }
    };

    getCountryData();
  }, [categoryName4]);

    //  ------------------------------SIXTH textfield------------------------------------------//
    const [country5, setCountry5] = useState([]);
    const [categoryName5, setCategoryName5] = useState("");
    const [selectedOption5, setSelectedOption5] = useState("");
    const [isDropdownOpen5, setIsDropdownOpen5] = useState(false);
    const handleSearchChange5 = (event) => {
      setCategoryName5(event.target.value);
      setSelectedOption5("");
      setIsDropdownOpen5(!!event.target.value);
    };
  
    const handleOptionSelect5= (option) => {
      setSelectedOption5(option);
      setCategoryName5("");
      setIsDropdownOpen5(false);
    };
    const handleInputChange5 = (event) => {
      setCategoryName5(event.target.value);
    };
  
    const filteredOptions5 = country5.filter((option) =>
      option.toLowerCase().includes(categoryName5.toLowerCase())
    );
  
    useEffect(() => {
      const getCountryData = async () => {
        try {
          // console.log(categoryName1, "aaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaa");
          const response = await fetch(
            `${process.env.REACT_APP_BASE_URL}/categories/searchCategoriesName?categoryName=${categoryName5}`
          );
          if (!response.ok) {
            // throw new Error('Data not valid');
          }
  
          const data = await response.json();
          if (data && Array.isArray(data.data)) {
            setCountry5(data.data.map((item) => item.categoryName));
          }
        } catch (error) {
          console.error("Error fetching country data:", error);
        }
      };
  
      getCountryData();
    }, [categoryName5]);
 //  ------------------------------SEVENTH textfield------------------------------------------//
       const [country6, setCountry6] = useState([]);
       const [categoryName6, setCategoryName6] = useState("");
       const [selectedOption6, setSelectedOption6] = useState("");
       const [isDropdownOpen6, setIsDropdownOpen6] = useState(false);
       const handleSearchChange6 = (event) => {
         setCategoryName6(event.target.value);
         setSelectedOption6("");
         setIsDropdownOpen6(!!event.target.value);
       };
     
       const handleOptionSelect6= (option) => {
         setSelectedOption6(option);
         setCategoryName6("");
         setIsDropdownOpen6(false);
       };
       const handleInputChange6 = (event) => {
         setCategoryName6(event.target.value);
       };
     
       const filteredOptions6 = country6.filter((option) =>
         option.toLowerCase().includes(categoryName6.toLowerCase())
       );
     
       useEffect(() => {
         const getCountryData = async () => {
           try {
             // console.log(categoryName1, "aaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaa");
             const response = await fetch(
               `${process.env.REACT_APP_BASE_URL}/categories/searchCategoriesName?categoryName=${categoryName6}`
             );
             if (!response.ok) {
               // throw new Error('Data not valid');
             }
     
             const data = await response.json();
             if (data && Array.isArray(data.data)) {
               setCountry6(data.data.map((item) => item.categoryName));
             }
           } catch (error) {
             console.error("Error fetching country data:", error);
           }
         };
     
         getCountryData();
       }, [categoryName6]);

//------------------------------Eighth textfield------------------------------------------//
       const [country7, setCountry7] = useState([]);
       const [categoryName7, setCategoryName7] = useState("");
       const [selectedOption7, setSelectedOption7] = useState("");
       const [isDropdownOpen7, setIsDropdownOpen7] = useState(false);
       const handleSearchChange7 = (event) => {
         setCategoryName7(event.target.value);
         setSelectedOption7("");
         setIsDropdownOpen7(!!event.target.value);
       };
     
       const handleOptionSelect7= (option) => {
         setSelectedOption7(option);
         setCategoryName7("");
         setIsDropdownOpen7(false);
       };
       const handleInputChange7 = (event) => {
         setCategoryName7(event.target.value);
       };
     
       const filteredOptions7 = country7.filter((option) =>
         option.toLowerCase().includes(categoryName7.toLowerCase())
       );
     
       useEffect(() => {
         const getCountryData = async () => {
           try {
             // console.log(categoryName1, "aaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaa");
             const response = await fetch(
               `${process.env.REACT_APP_BASE_URL}/categories/searchCategoriesName?categoryName=${categoryName7}`
             );
             if (!response.ok) {
               // throw new Error('Data not valid');
             }
     
             const data = await response.json();
             if (data && Array.isArray(data.data)) {
               setCountry7(data.data.map((item) => item.categoryName));
             }
           } catch (error) {
             console.error("Error fetching country data:", error);
           }
         };
     
         getCountryData();
       }, [categoryName7]);
//------------------------------Nineth textfield------------------------------------------//
       const [country8, setCountry8] = useState([]);
       const [categoryName8, setCategoryName8] = useState("");
       const [selectedOption8, setSelectedOption8] = useState("");
       const [isDropdownOpen8, setIsDropdownOpen8] = useState(false);
       const handleSearchChange8 = (event) => {
         setCategoryName8(event.target.value);
         setSelectedOption8("");
         setIsDropdownOpen8(!!event.target.value);
       };
     
       const handleOptionSelect8= (option) => {
         setSelectedOption8(option);
         setCategoryName8("");
         setIsDropdownOpen8(false);
       };
       const handleInputChange8 = (event) => {
         setCategoryName8(event.target.value);
       };
     
       const filteredOptions8 = country8.filter((option) =>
         option.toLowerCase().includes(categoryName8.toLowerCase())
       );
     
       useEffect(() => {
         const getCountryData = async () => {
           try {
             // console.log(categoryName1, "aaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaa");
             const response = await fetch(
               `${process.env.REACT_APP_BASE_URL}/categories/searchCategoriesName?categoryName=${categoryName8}`
             );
             if (!response.ok) {
               // throw new Error('Data not valid');
             }
     
             const data = await response.json();
             if (data && Array.isArray(data.data)) {
               setCountry8(data.data.map((item) => item.categoryName));
             }
           } catch (error) {
             console.error("Error fetching country data:", error);
           }
         };
     
         getCountryData();
       }, [categoryName8]);
//------------------------------TENTH textfield------------------------------------------//
       const [country9, setCountry9] = useState([]);
       const [categoryName9, setCategoryName9] = useState("");
       const [selectedOption9, setSelectedOption9] = useState("");
       const [isDropdownOpen9, setIsDropdownOpen9] = useState(false);
       const handleSearchChange9 = (event) => {
         setCategoryName9(event.target.value);
         setSelectedOption9("");
         setIsDropdownOpen9(!!event.target.value);
       };
     
       const handleOptionSelect9= (option) => {
         setSelectedOption9(option);
         setCategoryName9("");
         setIsDropdownOpen9(false);
       };
       const handleInputChange9 = (event) => {
         setCategoryName9(event.target.value);
       };
     
       const filteredOptions9 = country9.filter((option) =>
         option.toLowerCase().includes(categoryName9.toLowerCase())
       );
     
       useEffect(() => {
         const getCountryData = async () => {
           try {
             // console.log(categoryName1, "aaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaa");
             const response = await fetch(
               `${process.env.REACT_APP_BASE_URL}/categories/searchCategoriesName?categoryName=${categoryName9}`
             );
             if (!response.ok) {
               // throw new Error('Data not valid');
             }
     
             const data = await response.json();
             if (data && Array.isArray(data.data)) {
               setCountry9(data.data.map((item) => item.categoryName));
             }
           } catch (error) {
             console.error("Error fetching country data:", error);
           }
         };
     
         getCountryData();
       }, [categoryName9]);
       //------------------------------ELEVENTH textfield------------------------------------------//
       const [country10, setCountry10] = useState([]);
       const [categoryName10, setCategoryName10] = useState("");
       const [selectedOption10, setSelectedOption10] = useState("");
       const [isDropdownOpen10, setIsDropdownOpen10] = useState(false);
       const handleSearchChange10 = (event) => {
         setCategoryName10(event.target.value);
         setSelectedOption10("");
         setIsDropdownOpen10(!!event.target.value);
       };
     
       const handleOptionSelect10= (option) => {
         setSelectedOption10(option);
         setCategoryName10("");
         setIsDropdownOpen10(false);
       };
       const handleInputChange10 = (event) => {
         setCategoryName10(event.target.value);
       };
     
       const filteredOptions10 = country10.filter((option) =>
         option.toLowerCase().includes(categoryName10.toLowerCase())
       );
     
       useEffect(() => {
         const getCountryData = async () => {
           try {
             // console.log(categoryName1, "aaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaa");
             const response = await fetch(
               `${process.env.REACT_APP_BASE_URL}/categories/searchCategoriesName?categoryName=${categoryName10}`
             );
             if (!response.ok) {
               // throw new Error('Data not valid');
             }
     
             const data = await response.json();
             if (data && Array.isArray(data.data)) {
               setCountry10(data.data.map((item) => item.categoryName));
             }
           } catch (error) {
             console.error("Error fetching country data:", error);
           }
         };
     
         getCountryData();
       }, [categoryName10]);
  //------------------------------13 textfield------------------------------------------//
  const [country11, setCountry11] = useState([]);
  const [categoryName11, setCategoryName11] = useState("");
  const [selectedOption11, setSelectedOption11] = useState("");
  const [isDropdownOpen11, setIsDropdownOpen11] = useState(false);
  const handleSearchChange11 = (event) => {
    setCategoryName11(event.target.value);
    setSelectedOption11("");
    setIsDropdownOpen11(!!event.target.value);
  };

  const handleOptionSelect11= (option) => {
    setSelectedOption11(option);
    setCategoryName11("");
    setIsDropdownOpen11(false);
  };
  const handleInputChange11 = (event) => {
    setCategoryName11(event.target.value);
  };

  const filteredOptions11 = country11.filter((option) =>
    option.toLowerCase().includes(categoryName12.toLowerCase())
  );

  useEffect(() => {
    const getCountryData = async () => {
      try {
        // console.log(categoryName1, "aaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaa");
        const response = await fetch(
          `${process.env.REACT_APP_BASE_URL}/categories/searchCategoriesName?categoryName=${categoryName11}`
        );
        if (!response.ok) {
          // throw new Error('Data not valid');
        }

        const data = await response.json();
        if (data && Array.isArray(data.data)) {
          setCountry11(data.data.map((item) => item.categoryName));
        }
      } catch (error) {
        console.error("Error fetching country data:", error);
      }
    };

    getCountryData();
  }, [categoryName11]);
     
  //------------------------------13 textfield------------------------------------------//
  const [country12, setCountry12] = useState([]);
  const [categoryName12, setCategoryName12] = useState("");
  const [selectedOption12, setSelectedOption12] = useState("");
  const [isDropdownOpen12, setIsDropdownOpen12] = useState(false);
  const handleSearchChange12 = (event) => {
    setCategoryName12(event.target.value);
    setSelectedOption12("");
    setIsDropdownOpen12(!!event.target.value);
  };

  const handleOptionSelect12= (option) => {
    setSelectedOption12(option);
    setCategoryName12("");
    setIsDropdownOpen12(false);
  };
  const handleInputChange12 = (event) => {
    setCategoryName12(event.target.value);
  };

  const filteredOptions12 = country12.filter((option) =>
    option.toLowerCase().includes(categoryName12.toLowerCase())
  );

  useEffect(() => {
    const getCountryData = async () => {
      try {
        // console.log(categoryName1, "aaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaa");
        const response = await fetch(
          `${process.env.REACT_APP_BASE_URL}/categories/searchCategoriesName?categoryName=${categoryName12}`
        );
        if (!response.ok) {
          // throw new Error('Data not valid');
        }

        const data = await response.json();
        if (data && Array.isArray(data.data)) {
          setCountry12(data.data.map((item) => item.categoryName));
        }
      } catch (error) {
        console.error("Error fetching country data:", error);
      }
    };

    getCountryData();
  }, [categoryName12]);
// ----------------------------------14 textfield----------------------------------------------------------------
  const [country13, setCountry13] = useState([]);
  const [categoryName13, setCategoryName13] = useState("");
  const [selectedOption13, setSelectedOption13] = useState("");
  const [isDropdownOpen13, setIsDropdownOpen13] = useState(false);
  const handleSearchChange13 = (event) => {
    setCategoryName13(event.target.value);
    setSelectedOption13("");
    setIsDropdownOpen13(!!event.target.value);
  };

  const handleOptionSelect13= (option) => {
    setSelectedOption13(option);
    setCategoryName13("");
    setIsDropdownOpen13(false);
  };
  const handleInputChange13 = (event) => {
    setCategoryName13(event.target.value);
  };

  const filteredOptions13 = country13.filter((option) =>
    option.toLowerCase().includes(categoryName13.toLowerCase())
  );

  useEffect(() => {
    const getCountryData = async () => {
      try {
        // console.log(categoryName1, "aaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaa");
        const response = await fetch(
          `${process.env.REACT_APP_BASE_URL}/categories/searchCategoriesName?categoryName=${categoryName13}`
        );
        if (!response.ok) {
          // throw new Error('Data not valid');
        }

        const data = await response.json();
        if (data && Array.isArray(data.data)) {
          setCountry13(data.data.map((item) => item.categoryName));
        }
      } catch (error) {
        console.error("Error fetching country data:", error);
      }
    };

    getCountryData();
  }, [categoryName13]);

  // ----------------------------------15 textfield----------------------------------------------------------------
  const [country14, setCountry14] = useState([]);
  const [categoryName14, setCategoryName14] = useState("");
  const [selectedOption14, setSelectedOption14] = useState("");
  const [isDropdownOpen14, setIsDropdownOpen14] = useState(false);
  const handleSearchChange14 = (event) => {
    setCategoryName14(event.target.value);
    setSelectedOption14("");
    setIsDropdownOpen14(!!event.target.value);
  };

  const handleOptionSelect14= (option) => {
    setSelectedOption14(option);
    setCategoryName14("");
    setIsDropdownOpen14(false);
  };
  const handleInputChange14 = (event) => {
    setCategoryName14(event.target.value);
  };

  const filteredOptions14 = country14.filter((option) =>
    option.toLowerCase().includes(categoryName14.toLowerCase())
  );

  useEffect(() => {
    const getCountryData = async () => {
      try {
        // console.log(categoryName1, "aaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaa");
        const response = await fetch(
          `${process.env.REACT_APP_BASE_URL}/categories/searchCategoriesName?categoryName=${categoryName14}`
        );
        if (!response.ok) {
          // throw new Error('Data not valid');
        }

        const data = await response.json();
        if (data && Array.isArray(data.data)) {
          setCountry14(data.data.map((item) => item.categoryName));
        }
      } catch (error) {
        console.error("Error fetching country data:", error);
      }
    };

    getCountryData();
  }, [categoryName14]);
//---------------------------------------------Index------------------------------------------------------------//
const [categoryListIndex, setcategoryListIndex] = useState([]);

const handlePost = async (categoryName, categoryListIndex) => {
    try {
    

      const details = {
        categoryName: [categoryName],
        categoryListIndex: [categoryListIndex],
      };

      // console.log(categoryListIndex, "ssssssssssssssssssssssssssss");
      // console.log(categoryName,"5555555555555555555555555555555555555555555")
      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}/categories/createCategoriesList`,
        {
          method: "POST",
          body: JSON.stringify(details),
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      const responseData = await response.json();

      if (response.ok) {
        console.log("Data posted successfully:", responseData);
        setCategoryName("");
        setcategoryListIndex("5");
      } else {
        console.error("Failed to post data:", responseData);
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const handleInputChanges = (event) => {
    setcategoryListIndex(event.target.value);
  };
//-------------------------------------------GET DATA IN TEXTFIELD--------------------------------------------//
const [indexedData, setIndexedData] = useState([]);
const [data, setData] = useState([]);
const [firstCategory, setFirstCategory] = useState("");
const [firstCategory1, setFirstCategory1] = useState("");
const [firstCategory2, setFirstCategory2] = useState("");
const [firstCategory3, setFirstCategory3] = useState("");
const [firstCategory4, setFirstCategory4] = useState("");
const [firstCategory5, setFirstCategory5] = useState("");
const [firstCategory6, setFirstCategory6] = useState("");
const [firstCategory7, setFirstCategory7] = useState("");
const [firstCategory8, setFirstCategory8] = useState("");
const [firstCategory9, setFirstCategory9] = useState("");
const [firstCategory10, setFirstCategory10] = useState("");
const [firstCategory11, setFirstCategory11] = useState("");
const [firstCategory12, setFirstCategory12] = useState("");
const [firstCategory13, setFirstCategory13] = useState("");
const [firstCategory14, setFirstCategory14] = useState("");


const HomeCategory = [];

useEffect(() => {
  const fetchData = async () => {
    try {
      const result = await fetch(
        `${process.env.REACT_APP_BASE_URL}/categories/getCategoriesLists`
      );
      const resp = await result.json();
      setData(resp.data);

      if (resp.data && Array.isArray(resp.data)) {
        const indexedData = resp.data.map((item, index) => ({
          ...item,
          index: index + 1,
        }));
        setIndexedData(indexedData);
        resp.data.forEach((item) => {
          HomeCategory.push(item.categoryName ? item.categoryName : "testEample");
        });

        console.log(HomeCategory, "HomeCategory");
        console.log(HomeCategory[0], "sadasdd");
        console.log(HomeCategory[8], "uuuuuuuuuuuuuuuuuuuuuuuuu");
        if (HomeCategory.length > 0) {
          setFirstCategory(HomeCategory[0]);
          setFirstCategory1(HomeCategory[1]);
          setFirstCategory2(HomeCategory[2]);
          setFirstCategory3(HomeCategory[3]);
          setFirstCategory4(HomeCategory[4]);
          setFirstCategory5(HomeCategory[5]);
          setFirstCategory6(HomeCategory[6]);
          setFirstCategory7(HomeCategory[7]);
          setFirstCategory8(HomeCategory[8]);
          setFirstCategory9(HomeCategory[9]);
          setFirstCategory10(HomeCategory[10]);
          setFirstCategory11(HomeCategory[11]);
          setFirstCategory12(HomeCategory[12]);
          setFirstCategory13(HomeCategory[13]);
          setFirstCategory14(HomeCategory[14]);
        }
        console.log(firstCategory, "first");
        console.log(firstCategory1);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  fetchData();
}, []);


  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox py={3}>
        <form
          style={{
            background: "white",
            padding: "10px",
            borderRadius: "10px",
            boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px",
          }}
          autoComplete="off"
          //   onSubmit={handleUpdateCategory}
        >
          <div style={{ padding: "5px" }}>
            <></>
            <div style={{ display: "flex", gap: "40px" }}>
              <div style={{ position: "relative", width: "45%" }}>
                {!selectedOption && (
                  <input
                    type="text"
                    // value={categoryName}
                    defaultValue={firstCategory}
                    onChange={handleSearchChange}
                    placeholder="--Search CategoryName--"
                    style={{
                      width: "100%",
                      padding: "8px",
                      border: "1px solid #ced4da",
                      borderRadius: "4px",
                      appearance: "none",
                    }}
                  />
                )}

                {isDropdownOpen && !selectedOption && (
                  <div
                    className="dropdown"
                    style={{ position: "absolute", width: "100%", top: "100%", zIndex: "1" }}
                  >
                    {filteredOptions.length > 0 ? (
                      filteredOptions.map((option, index) => (
                        <div
                          key={index}
                          onClick={() => handleOptionSelect(option)}
                          className={selectedOption === option ? "selected" : ""}
                          style={{ padding: "8px", background: "#fff", cursor: "pointer" }}
                        >
                          {option}
                        </div>
                      ))
                    ) : (
                      <div className="no-results" style={{ padding: "8px", background: "#fff" }}>
                        No results found
                      </div>
                    )}
                  </div>
                )}

                {selectedOption && (
                  <div style={{ position: "relative" }}>
                    <input
                      type="text"
                      value={selectedOption}
                      onChange={(e) => setSelectedOption(e.target.value)}
                      style={{
                        width: "100%",
                        padding: "8px",
                        border: "1px solid #ced4da",
                        borderRadius: "4px",
                      }}
                    />
                    <SaveAltOutlinedIcon
                    style={{
                      position: "absolute",
                      top: "50%",
                      right: "5px",
                      transform: "translateY(-50%)",
                      cursor: "pointer",
                      color: "green",
                    }}
                    onClick={() => handlePost(categoryName, categoryListIndex)}
                  />

                    {/* <div>
                      <input
                        type="text"
                        value={categoryName}
                        onChange={handleInputChange}
                        placeholder="Enter category name"
                      />

                      <SaveAltOutlinedIcon
                        style={{
                          cursor: "pointer",
                          color: "green",
                        }}
                        onClick={() => handlePost(categoryName, categoryListIndex)}
                      />
                    </div> */}
                  </div>
                )}
              </div>

              <div style={{ position: "relative", width: "45%" }}>
                {!selectedOption1 && (
                  <input
                    type="text"
                    // value={categoryName}
                    defaultValue={firstCategory1}
                    onChange={handleSearchChange1}
                    placeholder="--Search CategoryName--"
                    style={{
                      width: "100%",
                      padding: "8px",
                      border: "1px solid #ced4da",
                      borderRadius: "4px",
                      appearance: "none",
                    }}
                  />
                )}

                {isDropdownOpen1 && !selectedOption1 && (
                  <div
                    className="dropdown"
                    style={{ position: "absolute", width: "100%", top: "100%", zIndex: "1" }}
                  >
                    {filteredOptions1.length > 0 ? (
                      filteredOptions1.map((option, index) => (
                        <div
                          key={index}
                          onClick={() => handleOptionSelect1(option)}
                          className={selectedOption1 === option ? "selected" : ""}
                          style={{ padding: "8px", background: "#fff", cursor: "pointer" }}
                        >
                          {option}
                        </div>
                      ))
                    ) : (
                      <div className="no-results" style={{ padding: "8px", background: "#fff" }}>
                        No results found
                      </div>
                    )}
                  </div>
                )}

                {selectedOption1 && (
                  <div style={{ position: "relative" }}>
                    <input
                      type="text"
                      value={selectedOption1}
                      onChange={(e) => setSelectedOption1(e.target.value)}
                      style={{
                        width: "100%",
                        padding: "8px",
                        border: "1px solid #ced4da",
                        borderRadius: "4px",
                      }}
                    />
                    <SaveAltOutlinedIcon
                    style={{
                      position: "absolute",
                      top: "50%",
                      right: "5px",
                      transform: "translateY(-50%)",
                      cursor: "pointer",
                      color: "green",
                    }}
                    onClick={() => handlePost(categoryName, categoryListIndex)}
                  />
                    {/* <div>
                      <input
                        type="text"
                        value={categoryName1}
                        onChange={handleInputChange1}
                        placeholder="Enter category name"
                      />

                      <SaveAltOutlinedIcon
                        style={{
                          cursor: "pointer",
                          color: "green",
                        }}
                        onClick={() => handlePost(categoryName, categoryListIndex)}
                      />
                    </div> */}
                  </div>
                )}
              </div>

              <div style={{ position: "relative", width: "45%" }}>
                {!selectedOption2 && (
                  <input
                    type="text"
                    // value={categoryName2}
                    defaultValue={firstCategory2}
                    onChange={handleSearchChange2}
                    placeholder="--Search CategoryName--"
                    style={{
                      width: "100%",
                      padding: "8px",
                      border: "1px solid #ced4da",
                      borderRadius: "4px",
                      appearance: "none",
                    }}
                  />
                )}

                {isDropdownOpen2 && !selectedOption2 && (
                  <div
                    className="dropdown"
                    style={{ position: "absolute", width: "100%", top: "100%", zIndex: "1" }}
                  >
                    {filteredOptions2.length > 0 ? (
                      filteredOptions2.map((option, index) => (
                        <div
                          key={index}
                          onClick={() => handleOptionSelect2(option)}
                          className={selectedOption2 === option ? "selected" : ""}
                          style={{ padding: "8px", background: "#fff", cursor: "pointer" }}
                        >
                          {option}
                        </div>
                      ))
                    ) : (
                      <div className="no-results" style={{ padding: "8px", background: "#fff" }}>
                        No results found
                      </div>
                    )}
                  </div>
                )}

                {selectedOption2 && (
                  <div style={{ position: "relative" }}>
                    <input
                      type="text"
                      value={selectedOption2}
                      onChange={(e) => setSelectedOption2(e.target.value)}
                      style={{
                        width: "100%",
                        padding: "8px",
                        border: "1px solid #ced4da",
                        borderRadius: "4px",
                      }}
                    />
                    <SaveAltOutlinedIcon
                    style={{
                      position: "absolute",
                      top: "50%",
                      right: "5px",
                      transform: "translateY(-50%)",
                      cursor: "pointer",
                      color: "green",
                    }}
                    onClick={() => handlePost(categoryName, categoryListIndex)}
                  />
                    {/* <div>
                      <input
                        type="text"
                        value={categoryName2}
                        onChange={handleInputChange2}
                        placeholder="Enter category name"
                      />

                      <SaveAltOutlinedIcon
                        style={{
                          cursor: "pointer",
                          color: "green",
                        }}
                        onClick={() => handlePost(categoryName, categoryListIndex)}
                      />
                    </div> */}
                  </div>
                )}
              </div>
            </div>
          </div>

          <div style={{ padding: "5px" }}>
            <></>
            <div style={{ display: "flex", gap: "40px" }}>
              <div style={{ position: "relative", width: "45%" }}>
                {!selectedOption3 && (
                  <input
                    type="text"
                    // value={categoryName3}
                    defaultValue={firstCategory3}
                    onChange={handleSearchChange3}
                    placeholder="--Search CategoryName--"
                    style={{
                      width: "100%",
                      padding: "8px",
                      border: "1px solid #ced4da",
                      borderRadius: "4px",
                      appearance: "none",
                    }}
                  />
                )}

                {isDropdownOpen3 && !selectedOption3 && (
                  <div
                    className="dropdown"
                    style={{ position: "absolute", width: "100%", top: "100%", zIndex: "1" }}
                  >
                    {filteredOptions3.length > 0 ? (
                      filteredOptions3.map((option, index) => (
                        <div
                          key={index}
                          onClick={() => handleOptionSelect3(option)}
                          className={selectedOption3 === option ? "selected" : ""}
                          style={{ padding: "8px", background: "#fff", cursor: "pointer" }}
                        >
                          {option}
                        </div>
                      ))
                    ) : (
                      <div className="no-results" style={{ padding: "8px", background: "#fff" }}>
                        No results found
                      </div>
                    )}
                  </div>
                )}

                {selectedOption3 && (
                  <div style={{ position: "relative" }}>
                    <input
                      type="text"
                      value={selectedOption3}
                      onChange={(e) => setSelectedOption3(e.target.value)}
                      style={{
                        width: "100%",
                        padding: "8px",
                        border: "1px solid #ced4da",
                        borderRadius: "4px",
                      }}
                    />
                    <SaveAltOutlinedIcon
                    style={{
                      position: "absolute",
                      top: "50%",
                      right: "5px",
                      transform: "translateY(-50%)",
                      cursor: "pointer",
                      color: "green",
                    }}
                    onClick={() => handlePost(categoryName, categoryListIndex)}
                  />

                    {/* <div>
                      <input
                        type="text"
                        value={categoryName3}
                        onChange={handleInputChange}
                        placeholder="Enter category name"
                      />

                      <SaveAltOutlinedIcon
                        style={{
                          cursor: "pointer",
                          color: "green",
                        }}
                        onClick={() => handlePost(categoryName, categoryListIndex)}
                      />
                    </div> */}
                  </div>
                )}
              </div>

              <div style={{ position: "relative", width: "45%" }}>
                {!selectedOption4 && (
                  <input
                    type="text"
                    defaultValue={firstCategory4}
                    onChange={handleSearchChange4}
                    placeholder="--Search CategoryName--"
                    style={{
                      width: "100%",
                      padding: "8px",
                      border: "1px solid #ced4da",
                      borderRadius: "4px",
                      appearance: "none",
                    }}
                  />
                )}

                {isDropdownOpen4 && !selectedOption4 && (
                  <div
                    className="dropdown"
                    style={{ position: "absolute", width: "100%", top: "100%", zIndex: "1" }}
                  >
                    {filteredOptions4.length > 0 ? (
                      filteredOptions4.map((option, index) => (
                        <div
                          key={index}
                          onClick={() => handleOptionSelect4(option)}
                          className={selectedOption4 === option ? "selected" : ""}
                          style={{ padding: "8px", background: "#fff", cursor: "pointer" }}
                        >
                          {option}
                        </div>
                      ))
                    ) : (
                      <div className="no-results" style={{ padding: "8px", background: "#fff" }}>
                        No results found
                      </div>
                    )}
                  </div>
                )}

                {selectedOption4 && (
                  <div style={{ position: "relative" }}>
                    <input
                      type="text"
                      value={selectedOption4}
                      onChange={(e) => setSelectedOption4(e.target.value)}
                      style={{
                        width: "100%",
                        padding: "8px",
                        border: "1px solid #ced4da",
                        borderRadius: "4px",
                      }}
                    />

<SaveAltOutlinedIcon
                    style={{
                      position: "absolute",
                      top: "50%",
                      right: "5px",
                      transform: "translateY(-50%)",
                      cursor: "pointer",
                      color: "green",
                    }}
                    onClick={() => handlePost(categoryName, categoryListIndex)}
                  />
                    {/* <div>
                      <input
                        type="text"
                        value={categoryName4}
                        onChange={handleInputChange4}
                        placeholder="Enter category name"
                      />

                      <SaveAltOutlinedIcon
                        style={{
                          cursor: "pointer",
                          color: "green",
                        }}
                        onClick={() => handlePost(categoryName, categoryListIndex)}
                      />
                    </div> */}
                  </div>
                )}
              </div>

              <div style={{ position: "relative", width: "45%" }}>
                {!selectedOption5 && (
                  <input
                    type="text"
                    // value={categoryName5}
                    defaultValue={firstCategory5}
                    onChange={handleSearchChange5}
                    placeholder="--Search CategoryName--"
                    style={{
                      width: "100%",
                      padding: "8px",
                      border: "1px solid #ced4da",
                      borderRadius: "4px",
                      appearance: "none",
                    }}
                  />
                )}

                {isDropdownOpen5 && !selectedOption5 && (
                  <div
                    className="dropdown"
                    style={{ position: "absolute", width: "100%", top: "100%", zIndex: "1" }}
                  >
                    {filteredOptions5.length > 0 ? (
                      filteredOptions5.map((option, index) => (
                        <div
                          key={index}
                          onClick={() => handleOptionSelect5(option)}
                          className={selectedOption5 === option ? "selected" : ""}
                          style={{ padding: "8px", background: "#fff", cursor: "pointer" }}
                        >
                          {option}
                        </div>
                      ))
                    ) : (
                      <div className="no-results" style={{ padding: "8px", background: "#fff" }}>
                        No results found
                      </div>
                    )}
                  </div>
                )}

                {selectedOption5 && (
                  <div style={{ position: "relative" }}>
                    <input
                      type="text"
                      value={selectedOption5}
                      onChange={(e) => setSelectedOption5(e.target.value)}
                      style={{
                        width: "100%",
                        padding: "8px",
                        border: "1px solid #ced4da",
                        borderRadius: "4px",
                      }}
                    />
                    <SaveAltOutlinedIcon
                    style={{
                      position: "absolute",
                      top: "50%",
                      right: "5px",
                      transform: "translateY(-50%)",
                      cursor: "pointer",
                      color: "green",
                    }}
                    onClick={() => handlePost(categoryName, categoryListIndex)}
                  />
                    {/* <div>
                      <input
                        type="text"
                        value={categoryName5}
                        onChange={handleInputChange5}
                        placeholder="Enter category name"
                      />

                      <SaveAltOutlinedIcon
                        style={{
                          cursor: "pointer",
                          color: "green",
                        }}
                        onClick={() => handlePost(categoryName, categoryListIndex)}
                      />
                    </div> */}
                  </div>
                )}
              </div>
            </div>
          </div>

          <div style={{ padding: "5px" }}>
            <></>
            <div style={{ display: "flex", gap: "40px" }}>
              <div style={{ position: "relative", width: "45%" }}>
                {!selectedOption6 && (
                  <input
                    type="text"
                    // value={categoryName6}
                    defaultValue={firstCategory6}
                    onChange={handleSearchChange6}
                    placeholder="--Search CategoryName--"
                    style={{
                      width: "100%",
                      padding: "8px",
                      border: "1px solid #ced4da",
                      borderRadius: "4px",
                      appearance: "none",
                    }}
                  />
                )}

                {isDropdownOpen6 && !selectedOption6 && (
                  <div
                    className="dropdown"
                    style={{ position: "absolute", width: "100%", top: "100%", zIndex: "1" }}
                  >
                    {filteredOptions6.length > 0 ? (
                      filteredOptions6.map((option, index) => (
                        <div
                          key={index}
                          onClick={() => handleOptionSelect6(option)}
                          className={selectedOption6 === option ? "selected" : ""}
                          style={{ padding: "8px", background: "#fff", cursor: "pointer" }}
                        >
                          {option}
                        </div>
                      ))
                    ) : (
                      <div className="no-results" style={{ padding: "8px", background: "#fff" }}>
                        No results found
                      </div>
                    )}
                  </div>
                )}

                {selectedOption6 && (
                  <div style={{ position: "relative" }}>
                    <input
                      type="text"
                      value={selectedOption6}
                      onChange={(e) => setSelectedOption6(e.target.value)}
                      style={{
                        width: "100%",
                        padding: "8px",
                        border: "1px solid #ced4da",
                        borderRadius: "4px",
                      }}
                    />
                    <SaveAltOutlinedIcon
                    style={{
                      position: "absolute",
                      top: "50%",
                      right: "5px",
                      transform: "translateY(-50%)",
                      cursor: "pointer",
                      color: "green",
                    }}
                    onClick={() => handlePost(categoryName, categoryListIndex)}
                  />

                    {/* <div>
                      <input
                        type="text"
                        value={categoryName6}
                        onChange={handleInputChange}
                        placeholder="Enter category name"
                      />

                      <SaveAltOutlinedIcon
                        style={{
                          cursor: "pointer",
                          color: "green",
                        }}
                        onClick={() => handlePost(categoryName, categoryListIndex)}
                      />
                    </div> */}
                  </div>
                )}
              </div>

              <div style={{ position: "relative", width: "45%" }}>
                {!selectedOption7 && (
                  <input
                    type="text"
                    defaultValue={firstCategory7}
                    onChange={handleSearchChange7}
                    placeholder="--Search CategoryName--"
                    style={{
                      width: "100%",
                      padding: "8px",
                      border: "1px solid #ced4da",
                      borderRadius: "4px",
                      appearance: "none",
                    }}
                  />
                )}

                {isDropdownOpen7 && !selectedOption7 && (
                  <div
                    className="dropdown"
                    style={{ position: "absolute", width: "100%", top: "100%", zIndex: "1" }}
                  >
                    {filteredOptions7.length > 0 ? (
                      filteredOptions7.map((option, index) => (
                        <div
                          key={index}
                          onClick={() => handleOptionSelect7(option)}
                          className={selectedOption7 === option ? "selected" : ""}
                          style={{ padding: "8px", background: "#fff", cursor: "pointer" }}
                        >
                          {option}
                        </div>
                      ))
                    ) : (
                      <div className="no-results" style={{ padding: "8px", background: "#fff" }}>
                        No results found
                      </div>
                    )}
                  </div>
                )}

                {selectedOption7 && (
                  <div style={{ position: "relative" }}>
                    <input
                      type="text"
                      value={selectedOption7}
                      onChange={(e) => setSelectedOption7(e.target.value)}
                      style={{
                        width: "100%",
                        padding: "8px",
                        border: "1px solid #ced4da",
                        borderRadius: "4px",
                      }}
                    />
                    <SaveAltOutlinedIcon
                    style={{
                      position: "absolute",
                      top: "50%",
                      right: "5px",
                      transform: "translateY(-50%)",
                      cursor: "pointer",
                      color: "green",
                    }}
                    onClick={() => handlePost(categoryName, categoryListIndex)}
                  />
                    {/* <div>
                      <input
                        type="text"
                        value={categoryName7}
                        onChange={handleInputChange7}
                        placeholder="Enter category name"
                      />

                      <SaveAltOutlinedIcon
                        style={{
                          cursor: "pointer",
                          color: "green",
                        }}
                        onClick={() => handlePost(categoryName, categoryListIndex)}
                      />
                    </div> */}
                  </div>
                )}
              </div>

              <div style={{ position: "relative", width: "45%" }}>
                {!selectedOption8 && (
                  <input
                    type="text"
                    // value={categoryName8}
                    defaultValue={firstCategory8}
                    onChange={handleSearchChange8}
                    placeholder="--Search CategoryName--"
                    style={{
                      width: "100%",
                      padding: "8px",
                      border: "1px solid #ced4da",
                      borderRadius: "4px",
                      appearance: "none",
                    }}
                  />
                )}

                {isDropdownOpen8 && !selectedOption8 && (
                  <div
                    className="dropdown"
                    style={{ position: "absolute", width: "100%", top: "100%", zIndex: "1" }}
                  >
                    {filteredOptions8.length > 0 ? (
                      filteredOptions8.map((option, index) => (
                        <div
                          key={index}
                          onClick={() => handleOptionSelect8(option)}
                          className={selectedOption8 === option ? "selected" : ""}
                          style={{ padding: "8px", background: "#fff", cursor: "pointer" }}
                        >
                          {option}
                        </div>
                      ))
                    ) : (
                      <div className="no-results" style={{ padding: "8px", background: "#fff" }}>
                        No results found
                      </div>
                    )}
                  </div>
                )}

                {selectedOption8 && (
                  <div style={{ position: "relative" }}>
                    <input
                      type="text"
                      value={selectedOption8}
                      onChange={(e) => setSelectedOption8(e.target.value)}
                      style={{
                        width: "100%",
                        padding: "8px",
                        border: "1px solid #ced4da",
                        borderRadius: "4px",
                      }}
                    />
                    <SaveAltOutlinedIcon
                    style={{
                      position: "absolute",
                      top: "50%",
                      right: "5px",
                      transform: "translateY(-50%)",
                      cursor: "pointer",
                      color: "green",
                    }}
                    onClick={() => handlePost(categoryName, categoryListIndex)}
                  />
                    {/* <div>
                      <input
                        type="text"
                        value={categoryName8}
                        onChange={handleInputChange8}
                        placeholder="Enter category name"
                      />

                      <SaveAltOutlinedIcon
                        style={{
                          cursor: "pointer",
                          color: "green",
                        }}
                        onClick={() => handlePost(categoryName, categoryListIndex)}
                      />
                    </div> */}
                  </div>
                )}
              </div>
            </div>
          </div>


          <div style={{ padding: "5px" }}>
            <></>
            <div style={{ display: "flex", gap: "40px" }}>
              <div style={{ position: "relative", width: "45%" }}>
                {!selectedOption9 && (
                  <input
                    type="text"
                    // value={categoryName9}
                    defaultValue={firstCategory9}
                    onChange={handleSearchChange9}
                    placeholder="--Search CategoryName--"
                    style={{
                      width: "100%",
                      padding: "8px",
                      border: "1px solid #ced4da",
                      borderRadius: "4px",
                      appearance: "none",
                    }}
                  />
                )}

                {isDropdownOpen9 && !selectedOption9 && (
                  <div
                    className="dropdown"
                    style={{ position: "absolute", width: "100%", top: "100%", zIndex: "1" }}
                  >
                    {filteredOptions9.length > 0 ? (
                      filteredOptions9.map((option, index) => (
                        <div
                          key={index}
                          onClick={() => handleOptionSelect9(option)}
                          className={selectedOption9 === option ? "selected" : ""}
                          style={{ padding: "8px", background: "#fff", cursor: "pointer" }}
                        >
                          {option}
                        </div>
                      ))
                    ) : (
                      <div className="no-results" style={{ padding: "8px", background: "#fff" }}>
                        No results found
                      </div>
                    )}
                  </div>
                )}

                {selectedOption9 && (
                  <div style={{ position: "relative" }}>
                    <input
                      type="text"
                      value={selectedOption9}
                      onChange={(e) => setSelectedOption9(e.target.value)}
                      style={{
                        width: "100%",
                        padding: "8px",
                        border: "1px solid #ced4da",
                        borderRadius: "4px",
                      }}
                    />
<SaveAltOutlinedIcon
                    style={{
                      position: "absolute",
                      top: "50%",
                      right: "5px",
                      transform: "translateY(-50%)",
                      cursor: "pointer",
                      color: "green",
                    }}
                    onClick={() => handlePost(categoryName, categoryListIndex)}
                  />
                    {/* <div>
                      <input
                        type="text"
                        value={categoryName9}
                        onChange={handleInputChange}
                        placeholder="Enter category name"
                      />

                      <SaveAltOutlinedIcon
                        style={{
                          cursor: "pointer",
                          color: "green",
                        }}
                        onClick={() => handlePost(categoryName, categoryListIndex)}
                      />
                    </div> */}
                  </div>
                )}
              </div>

              <div style={{ position: "relative", width: "45%" }}>
                {!selectedOption10 && (
                  <input
                    type="text"
                    defaultValue={firstCategory10}
                    onChange={handleSearchChange10}
                    placeholder="--Search CategoryName--"
                    style={{
                      width: "100%",
                      padding: "8px",
                      border: "1px solid #ced4da",
                      borderRadius: "4px",
                      appearance: "none",
                    }}
                  />
                )}

                {isDropdownOpen10 && !selectedOption10 && (
                  <div
                    className="dropdown"
                    style={{ position: "absolute", width: "100%", top: "100%", zIndex: "1" }}
                  >
                    {filteredOptions10.length > 0 ? (
                      filteredOptions10.map((option, index) => (
                        <div
                          key={index}
                          onClick={() => handleOptionSelect10(option)}
                          className={selectedOption10 === option ? "selected" : ""}
                          style={{ padding: "8px", background: "#fff", cursor: "pointer" }}
                        >
                          {option}
                        </div>
                      ))
                    ) : (
                      <div className="no-results" style={{ padding: "8px", background: "#fff" }}>
                        No results found
                      </div>
                    )}
                  </div>
                )}

                {selectedOption10 && (
                  <div style={{ position: "relative" }}>
                    <input
                      type="text"
                      value={selectedOption10}
                      onChange={(e) => setSelectedOption10(e.target.value)}
                      style={{
                        width: "100%",
                        padding: "8px",
                        border: "1px solid #ced4da",
                        borderRadius: "4px",
                      }}
                    />
                    <SaveAltOutlinedIcon
                    style={{
                      position: "absolute",
                      top: "50%",
                      right: "5px",
                      transform: "translateY(-50%)",
                      cursor: "pointer",
                      color: "green",
                    }}
                    onClick={() => handlePost(categoryName, categoryListIndex)}
                  />
                    {/* <div>
                      <input
                        type="text"
                        value={categoryName10}
                        onChange={handleInputChange10}
                        placeholder="Enter category name"
                      />

                      <SaveAltOutlinedIcon
                        style={{
                          cursor: "pointer",
                          color: "green",
                        }}
                        onClick={() => handlePost(categoryName, categoryListIndex)}
                      />
                    </div> */}
                  </div>
                )}
              </div>

              <div style={{ position: "relative", width: "45%" }}>
                {!selectedOption11 && (
                  <input
                    type="text"
                    // value={categoryName11}
                    defaultValue={firstCategory11}
                    onChange={handleSearchChange11}
                    placeholder="--Search CategoryName--"
                    style={{
                      width: "100%",
                      padding: "8px",
                      border: "1px solid #ced4da",
                      borderRadius: "4px",
                      appearance: "none",
                    }}
                  />
                )}

                {isDropdownOpen11 && !selectedOption11 && (
                  <div
                    className="dropdown"
                    style={{ position: "absolute", width: "100%", top: "100%", zIndex: "1" }}
                  >
                    {filteredOptions11.length > 0 ? (
                      filteredOptions11.map((option, index) => (
                        <div
                          key={index}
                          onClick={() => handleOptionSelect11(option)}
                          className={selectedOption11 === option ? "selected" : ""}
                          style={{ padding: "8px", background: "#fff", cursor: "pointer" }}
                        >
                          {option}
                        </div>
                      ))
                    ) : (
                      <div className="no-results" style={{ padding: "8px", background: "#fff" }}>
                        No results found
                      </div>
                    )}
                  </div>
                )}

                {selectedOption11 && (
                  <div style={{ position: "relative" }}>
                    <input
                      type="text"
                      value={selectedOption11}
                      onChange={(e) => setSelectedOption11(e.target.value)}
                      style={{
                        width: "100%",
                        padding: "8px",
                        border: "1px solid #ced4da",
                        borderRadius: "4px",
                      }}
                    />

<SaveAltOutlinedIcon
                    style={{
                      position: "absolute",
                      top: "50%",
                      right: "5px",
                      transform: "translateY(-50%)",
                      cursor: "pointer",
                      color: "green",
                    }}
                    onClick={() => handlePost(categoryName, categoryListIndex)}
                  />
                    {/* <div>
                      <input
                        type="text"
                        value={categoryName11}
                        onChange={handleInputChange11}
                        placeholder="Enter category name"
                      />

                      <SaveAltOutlinedIcon
                        style={{
                          cursor: "pointer",
                          color: "green",
                        }}
                        onClick={() => handlePost(categoryName, categoryListIndex)}
                      />
                    </div> */}
                  </div>
                )}
              </div>
            </div>
          </div>


          <div style={{ padding: "5px" }}>
            <></>
            <div style={{ display: "flex", gap: "40px" }}>
              <div style={{ position: "relative", width: "45%" }}>
                {!selectedOption12 && (
                  <input
                    type="text"
                    // value={categoryName12}
                    defaultValue={firstCategory12}
                    onChange={handleSearchChange12}
                    placeholder="--Search CategoryName--"
                    style={{
                      width: "100%",
                      padding: "8px",
                      border: "1px solid #ced4da",
                      borderRadius: "4px",
                      appearance: "none",
                    }}
                  />
                )}

                {isDropdownOpen12 && !selectedOption12 && (
                  <div
                    className="dropdown"
                    style={{ position: "absolute", width: "100%", top: "100%", zIndex: "1" }}
                  >
                    {filteredOptions12.length > 0 ? (
                      filteredOptions12.map((option, index) => (
                        <div
                          key={index}
                          onClick={() => handleOptionSelect12(option)}
                          className={selectedOption12 === option ? "selected" : ""}
                          style={{ padding: "8px", background: "#fff", cursor: "pointer" }}
                        >
                          {option}
                        </div>
                      ))
                    ) : (
                      <div className="no-results" style={{ padding: "8px", background: "#fff" }}>
                        No results found
                      </div>
                    )}
                  </div>
                )}

                {selectedOption12 && (
                  <div style={{ position: "relative" }}>
                    <input
                      type="text"
                      value={selectedOption12}
                      onChange={(e) => setSelectedOption12(e.target.value)}
                      style={{
                        width: "100%",
                        padding: "8px",
                        border: "1px solid #ced4da",
                        borderRadius: "4px",
                      }}
                    />

<SaveAltOutlinedIcon
                    style={{
                      position: "absolute",
                      top: "50%",
                      right: "5px",
                      transform: "translateY(-50%)",
                      cursor: "pointer",
                      color: "green",
                    }}
                    onClick={() => handlePost(categoryName, categoryListIndex)}
                  />

                    {/* <div>
                      <input
                        type="text"
                        value={categoryName12}
                        onChange={handleInputChange}
                        placeholder="Enter category name"
                      />

                      <SaveAltOutlinedIcon
                        style={{
                          cursor: "pointer",
                          color: "green",
                        }}
                        onClick={() => handlePost(categoryName, categoryListIndex)}
                      />
                    </div> */}
                  </div>
                )}
              </div>

              <div style={{ position: "relative", width: "45%" }}>
                {!selectedOption13 && (
                  <input
                    type="text"
                    defaultValue={firstCategory13}
                    onChange={handleSearchChange13}
                    placeholder="--Search CategoryName--"
                    style={{
                      width: "100%",
                      padding: "8px",
                      border: "1px solid #ced4da",
                      borderRadius: "4px",
                      appearance: "none",
                    }}
                  />
                )}

                {isDropdownOpen13 && !selectedOption13 && (
                  <div
                    className="dropdown"
                    style={{ position: "absolute", width: "100%", top: "100%", zIndex: "1" }}
                  >
                    {filteredOptions13.length > 0 ? (
                      filteredOptions13.map((option, index) => (
                        <div
                          key={index}
                          onClick={() => handleOptionSelect13(option)}
                          className={selectedOption13 === option ? "selected" : ""}
                          style={{ padding: "8px", background: "#fff", cursor: "pointer" }}
                        >
                          {option}
                        </div>
                      ))
                    ) : (
                      <div className="no-results" style={{ padding: "8px", background: "#fff" }}>
                        No results found
                      </div>
                    )}
                  </div>
                )}

                {selectedOption13 && (
                  <div style={{ position: "relative" }}>
                    <input
                      type="text"
                      value={selectedOption13}
                      onChange={(e) => setSelectedOption13(e.target.value)}
                      style={{
                        width: "100%",
                        padding: "8px",
                        border: "1px solid #ced4da",
                        borderRadius: "4px",
                      }}
                    />
                    <SaveAltOutlinedIcon
                    style={{
                      position: "absolute",
                      top: "50%",
                      right: "5px",
                      transform: "translateY(-50%)",
                      cursor: "pointer",
                      color: "green",
                    }}
                    onClick={() => handlePost(categoryName, categoryListIndex)}
                  />
                    {/* <div>
                      <input
                        type="text"
                        value={categoryName13}
                        onChange={handleInputChange13}
                        placeholder="Enter category name"
                      />

                      <SaveAltOutlinedIcon
                        style={{
                          cursor: "pointer",
                          color: "green",
                        }}
                        onClick={() => handlePost(categoryName, categoryListIndex)}
                      />
                    </div> */}
                  </div>
                )}
              </div>

              <div style={{ position: "relative", width: "45%" }}>
                {!selectedOption14 && (
                  <input
                    type="text"
                    // value={categoryName14}
                    defaultValue={firstCategory14}
                    onChange={handleSearchChange14}
                    placeholder="--Search CategoryName--"
                    style={{
                      width: "100%",
                      padding: "8px",
                      border: "1px solid #ced4da",
                      borderRadius: "4px",
                      appearance: "none",
                    }}
                  />
                )}

                {isDropdownOpen14 && !selectedOption14 && (
                  <div
                    className="dropdown"
                    style={{ position: "absolute", width: "100%", top: "100%", zIndex: "1" }}
                  >
                    {filteredOptions14.length > 0 ? (
                      filteredOptions14.map((option, index) => (
                        <div
                          key={index}
                          onClick={() => handleOptionSelect14(option)}
                          className={selectedOption14 === option ? "selected" : ""}
                          style={{ padding: "8px", background: "#fff", cursor: "pointer" }}
                        >
                          {option}
                        </div>
                      ))
                    ) : (
                      <div className="no-results" style={{ padding: "8px", background: "#fff" }}>
                        No results found
                      </div>
                    )}
                  </div>
                )}

                {selectedOption14 && (
                  <div style={{ position: "relative" }}>
                    <input
                      type="text"
                      value={selectedOption14}
                      onChange={(e) => setSelectedOption14(e.target.value)}
                      style={{
                        width: "100%",
                        padding: "8px",
                        border: "1px solid #ced4da",
                        borderRadius: "4px",
                      }}
                    />
                    <SaveAltOutlinedIcon
                    style={{
                      position: "absolute",
                      top: "50%",
                      right: "5px",
                      transform: "translateY(-50%)",
                      cursor: "pointer",
                      color: "green",
                    }}
                    onClick={() => handlePost(categoryName, categoryListIndex)}
                  />
                    {/* <div>
                      <input
                        type="text"
                        value={categoryName14}
                        onChange={handleInputChange14}
                        placeholder="Enter category name"
                      />

                      <SaveAltOutlinedIcon
                        style={{
                          cursor: "pointer",
                          color: "green",
                        }}
                        onClick={() => handlePost(categoryName, categoryListIndex)}
                      />
                    </div> */}
                  </div>
                )}
              </div>
            </div>
          </div>
          <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
            <Button title={"Submit"} />
          </div>
        </form>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default EditShop;
